import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import {
  isRequiredIntegerGreaterThanOrEqual,
  makeIntegerRangeValidatorWithLabelsLower
} from 'utilities/validators.js';
import Dropdown from '../Dropdown';
import { round6 as round } from 'utilities/math';

import Input from 'components/Input';

const isGreaterThanTwo = isRequiredIntegerGreaterThanOrEqual(2);

class SettingsFormComponent extends React.PureComponent {
  isValidSuccess = (value, { oneSampleProportion: { numberOfTrials } }) =>
    makeIntegerRangeValidatorWithLabelsLower(
      1,
      numberOfTrials,
      1,
      'Number of Trials'
    )(value);

  formatFn = value => (value || value === 0 ? round(value) : '');

  renderVariableDropDowns = () => {
    const { variableOptions, levelsOptions, onLevelsOptionsChange, onVariablesOptionsChange } = this.props;

    if (!variableOptions || !variableOptions.length) {
      return null;
    }
    return (
      <>
        <Dropdown
          isClearable
          optionsList={variableOptions}
          label="Sample Variable"
          name="categoricalRowDataSet"
          onChange={onVariablesOptionsChange}
          placeholder="Select a Variable"
          id="variablesDropdown"
        />
        <Dropdown
          isClearable
          isDisabled={!levelsOptions.length}
          optionsList={levelsOptions}
          label="Success Group"
          name="levelsRowDataSet"
          onChange={onLevelsOptionsChange}
          placeholder="Select a Group"
          id="levelsDropdown"
        />
      </>
    );
  };

  render () {
    const { onNumberOfSuccessChange, onNumberOfTrialsChange } = this.props;

    return (
      <>
        {this.renderVariableDropDowns()}
        <div className="flex space-between baseline">
          <Field
            type="number"
            id="numberOfSuccess"
            component={Input}
            name="numberOfSuccess"
            label="Number\nof Successes"
            pattern="\d+"
            wrapperClassName="mb-15 relative width-48 iconTop two-lines"
            inputClassName="main-input__input"
            onChange={onNumberOfSuccessChange}
            format={this.formatFn}
            validate={this.isValidSuccess}
          />

          <Field
            type="number"
            id="numberOfTrials"
            component={Input}
            name="numberOfTrials"
            label="Number\nof Trials"
            pattern="\d+"
            wrapperClassName="mb-15 relative width-48 iconTop two-lines"
            inputClassName="main-input__input"
            onChange={onNumberOfTrialsChange}
            format={this.formatFn}
            validate={isGreaterThanTwo}
          />
        </div>
      </>
    );
  }
}

SettingsFormComponent.propTypes = {
  variableOptions: PropTypes.arrayOf(
    PropTypes.shape({
      variable: PropTypes.string,
      text: PropTypes.string
    })
  ).isRequired,
  levelsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      variable: PropTypes.string,
      text: PropTypes.string
    })
  ).isRequired,
  onLevelsOptionsChange: PropTypes.func.isRequired,
  onVariablesOptionsChange: PropTypes.func.isRequired,
  onNumberOfTrialsChange: PropTypes.func.isRequired,
  onNumberOfSuccessChange: PropTypes.func.isRequired
};

export default SettingsFormComponent;
